import ServiceIdentityTab from './ServiceIdentityTab';

export default ServiceIdentityTab;
